var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg404 = function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 241,
    viewBox: "0 0 280 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 120.501,
    r: 120.5,
    fill: "#F0CD4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.185 186.647L205.458 172.916L227.963 179.996L227.842 195.949C227.843 195.994 227.834 196.038 227.816 196.078C227.483 196.874 223.811 204.692 209.853 201.043C196.274 197.494 192.581 188.33 192.102 186.957C192.083 186.903 192.08 186.845 192.095 186.789C192.11 186.734 192.141 186.684 192.185 186.647Z",
    fill: "#347DC1",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.056 55.0787C268.577 52.8569 263.786 57.1252 259.371 69.6552C256.716 77.1894 248.218 85.6371 243.273 90.1673C243.258 90.1642 245.387 88.2171 245.375 88.202C249.903 82.1435 249.307 72.5875 250.772 67.5187C252.474 61.6241 251.628 44.966 252.545 40.5118C253.463 36.0576 255.074 24.0493 252.006 22.3183C248.938 20.5872 245.327 23.8746 244.172 28.8918C243.017 33.9091 240.721 53.9605 238.572 60.2375C237.692 62.8103 236.347 66.3365 235.081 69.598C235.458 67.8614 235.887 65.9013 236.3 63.682C237.998 54.2552 236.66 50.0703 235.46 38.0917C234.259 26.113 235.982 15.23 231.091 11.6714C226.2 8.11291 223.268 21.1638 222.315 31.7214C221.362 42.2791 222.785 52.7391 220.671 59.5729C218.852 65.462 217.396 68.0099 215.187 67.9951C212.978 67.9804 205.553 57.508 200.843 56.3785C197.232 55.5098 197.304 56.8706 193.459 58.3986C189.614 59.9266 184.345 60.5555 180.698 61.6498C177.051 62.744 171.945 73.2738 170.643 74.8508C170.123 75.4776 170.25 76.4686 170.845 77.4186C169.709 75.9812 168.423 74.6695 167.008 73.5058C163.009 70.3651 161.47 76.6367 162.854 82.9764C164.239 89.3161 161.153 91.2348 162.033 94.0951C162.912 96.9553 170.9 107.428 176.924 113.799C182.947 120.17 179.839 123.917 189.155 134.554C198.471 145.191 199.789 145.831 201.31 158.634C202.76 170.799 193.067 185.292 192.117 186.673C192.117 186.673 192.112 186.694 192.135 186.677C192.904 185.899 198.653 180.819 212.725 183.942C226.63 187.031 227.772 195.288 227.841 195.958C227.956 195.126 229.768 182.338 233.849 176.312C238.067 170.081 236.286 159.719 236.497 148.018C236.655 139.239 241.949 123.565 245.044 112.59C246.219 110.664 247.392 108.702 248.032 107.506C249.624 104.521 258.93 93.7607 261.028 92.4816C263.125 91.2025 262.953 87.8822 265.624 81.4535C268.295 75.0248 273.533 57.2999 271.056 55.0787ZM190.446 98.5988C186.379 99.3565 179.316 94.4638 177.675 89.3109C176.782 86.4853 174.857 82.9382 172.64 79.793C172.265 79.26 171.882 78.7407 171.495 78.2364C172.082 78.8414 172.794 79.3112 173.581 79.6131C174.368 79.9149 175.212 80.0414 176.053 79.9839C180.023 79.7025 184.761 72.1259 186.13 70.8185C187.499 69.5111 187.373 71.3212 192.12 70.8314C196.867 70.3416 192.513 67.7369 198.272 74.7872C204.031 81.8375 203.707 77.496 203.28 80.8147C202.852 84.1333 206.036 85.2388 206.446 91.6214C206.856 98.004 194.515 97.8381 190.446 98.5988Z",
    fill: "#5BA0E0",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.847 77.4097L171.504 78.2382",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.337 68.7922C174.912 69.2916 174.933 70.1639 174.895 70.9242C174.865 71.7807 174.768 72.6335 174.604 73.4747C174.23 75.2248 173.383 76.8388 172.155 78.1412",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.199 74.0546C164.219 75.698 165.106 77.4169 165.992 79.1357C166.294 79.6959 166.565 80.2729 166.801 80.8637C167.005 81.4304 167.175 82.0086 167.31 82.5954C167.533 83.5384 167.737 84.4881 167.923 85.4444C168.035 85.918 168.073 86.4061 168.034 86.8912C168.013 87.1334 167.94 87.368 167.819 87.5788C167.698 87.7895 167.532 87.9713 167.333 88.1113C166.932 88.3285 166.466 88.3923 166.022 88.2908C165.578 88.215 165.132 88.0577 164.705 87.979C164.236 87.9011 163.757 87.9082 163.291 88.0001",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.719 12.519C231.782 14.4241 231.949 16.3243 232.219 18.2112C232.301 19.013 232.496 19.7993 232.797 20.5472C233.102 21.2988 233.677 21.9095 234.409 22.2595",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M252.574 22.9598C252.344 23.741 252.236 24.5528 252.253 25.3668C252.271 26.251 252.437 27.1283 252.451 28.0149C252.479 29.3946 252.128 30.7835 252.393 32.1371C252.465 32.7104 252.761 33.2321 253.215 33.5898",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.037 55.3994L270.242 58.6703C270.082 59.2728 269.956 59.8838 269.865 60.5005C269.776 61.3281 269.765 62.1623 269.833 62.9919C269.83 63.1948 269.873 63.3958 269.958 63.5799C270.208 63.818 270.536 63.9567 270.881 63.9698",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M214.682 85.7081C215.03 89.2388 216.174 92.6449 218.029 95.6701C219.884 98.6954 222.401 101.261 225.391 103.174C227.604 104.566 230.078 105.6 231.93 107.437C234.849 110.333 235.706 114.65 236.428 118.696",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.068 94.1694C208.491 101.522 209.495 108.539 207.335 115.976C206.828 117.723 206.196 119.444 205.909 121.243C205.476 123.983 205.869 126.78 206.262 129.525",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.598 79.347C204.617 78.208 206.074 77.5339 207.567 77.2014C209.071 76.9251 210.601 76.813 212.129 76.867",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.453 77.5593C204.456 76.5167 205.901 76.0681 207.299 75.7129C207.845 75.5261 208.429 75.481 208.997 75.5819",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M215.186 68.0605C216.76 68.8687 218.66 68.4858 220.404 68.7731C221.054 68.8939 221.693 69.0674 222.316 69.2917C223.288 69.5696 224.216 69.9868 225.069 70.5303C225.93 71.0817 226.537 71.9511 226.758 72.9484",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M235.031 69.8436C235.44 70.7899 236.104 71.6044 236.949 72.1965C237.252 72.378 237.531 72.5971 237.78 72.8486C237.951 73.0641 238.09 73.3031 238.193 73.5582C239.008 75.3966 239.566 77.51 238.865 79.3953",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M248.698 106.441C249.263 104.684 249.486 101.751 248.607 100.131C247.476 98.0398 244.268 97.2137 244.072 94.8439",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M253.841 79.0579C254.181 79.4863 254.485 79.9417 254.751 80.4194C255.014 80.8339 255.163 81.3105 255.182 81.8008C255.166 82.3658 254.857 82.908 254.94 83.4621C255.07 83.9741 255.384 84.4203 255.822 84.7149C256.483 85.2452 257.222 85.6711 258.012 85.9777",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.058 79.1553C257.663 79.4581 258.221 79.8444 258.718 80.3028C259.013 80.5544 259.251 80.8652 259.418 81.2151C259.568 81.6758 259.613 82.1641 259.551 82.6446",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M260.21 67.5674C260.631 69.4891 261.705 71.2057 263.25 72.4245C263.467 72.5571 263.644 72.7456 263.762 72.9703C263.841 73.2775 263.808 73.6026 263.67 73.8881",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.557 60.2781C239.497 61.4772 240.673 61.3383 241.94 61.7242",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.976 58.9125C240.64 59.7392 242.225 60.3405 244.488 59.6046",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242.82 43.2517C244.163 44.603 245.902 45.4907 247.785 45.7856",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M222.564 31.348C224.368 32.8749 224.82 35.2912 227.892 35.2558",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M221.757 52.8615C222.812 55.3209 225.887 56.6566 228.498 55.7207",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.036 50.6396C223.395 53.4175 226.232 54.9199 227.508 53.459",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.75 69.9554C195.364 69.4956 195.843 68.8793 196.138 68.1709C196.432 67.4625 196.53 66.6881 196.423 65.9285",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.488 70.5801C187.276 69.787 187.159 68.4169 186.537 67.4896C185.916 66.5622 184.92 65.9668 183.957 65.3967",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M183.799 73.2737L182.826 70.8873",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M191.857 98.7425C189.731 99.613 188.778 102.102 188.508 104.385C188.344 105.679 188.178 107.227 187.018 107.825C186.145 108.27 184.952 108.024 184.228 108.674",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M179.158 92.4078C178.065 93.3893 176.788 94.1446 175.401 94.6302C174.014 95.1157 172.544 95.3218 171.077 95.2366",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M178.541 91.6877C177.586 92.64 176.527 93.0807 175.518 92.9572",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.594 145.897C202.673 144.513 206.19 141.84 208.614 138.281",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M199.976 150.216C203.044 149.836 205.735 152.108 207.983 154.226L213.785 159.686C216.174 161.936 218.641 164.234 221.688 165.458C224.735 166.682 228.539 166.6 230.969 164.391",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M236.62 157.342C234.981 156.927 233.431 157.185 231.738 157.139C230.044 157.093 228.217 156.695 227.139 155.392",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M236.668 159.413C235.468 159.413 232.37 160.377 231.486 159.436",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M201.99 161.388L205.713 163.85C206.067 164.086 206.474 164.447 206.343 164.854C206.252 165.148 205.942 165.287 205.803 165.552C205.575 166.008 205.98 166.525 206.354 166.864L209.121 169.451",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.063 147.183L202.604 145.162C201.956 145.565 201.271 146.005 200.948 146.694C200.625 147.383 200.873 148.396 201.613 148.595",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.248 94.2175C162.505 94.3509 162.786 94.4288 163.075 94.4463C163.364 94.4638 163.653 94.4205 163.924 94.319C164.528 94.1171 165.043 93.7123 165.381 93.1735",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M162.092 92.4116C162.272 92.5589 162.484 92.6631 162.711 92.7163C162.937 92.7695 163.173 92.7703 163.4 92.7186C163.622 92.6608 163.827 92.551 163.997 92.3982C164.168 92.2454 164.299 92.0541 164.381 91.8402",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M126.854 103.002C126.854 103.002 150.087 114.747 150.633 119.091C151.18 123.434 141.03 132.774 137.673 135.099C134.316 137.423 106.628 136.415 106.628 136.415L105.573 111.543L126.854 103.002Z",
    fill: "#347DC1",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50654 159.841C10.4476 170.976 18.9718 170.868 18.9718 170.868L33.7314 150.055L18.3781 133.246L4.95173 136.179C4.95173 136.179 0.273083 148.057 5.50654 159.841Z",
    fill: "#347DC1",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95179 136.179C4.95179 136.179 11.7025 134.528 16.7508 131.314C21.7992 128.1 26.6061 125.714 37.4187 123.345C48.2313 120.977 95.442 95.6147 100.448 91.6702C105.454 87.7258 114.639 92.0352 122.425 88.8095C130.21 85.5838 144.948 79.5558 151.187 78.7172C157.426 77.8787 191.365 80.5157 195.185 80.4978C199.004 80.4799 200.381 87.2491 192.563 89.4863C184.745 91.7234 183.848 91.9473 180.489 92.0897C177.13 92.2322 173.987 91.0013 171.817 91.2746C169.646 91.5479 165.432 93.0001 160.808 93.2868C156.184 93.5735 153.345 93.1502 151.378 93.9609C149.412 94.7717 148.786 97.1616 144.325 99.1704C139.865 101.179 135.172 102.103 128.343 104.031C121.513 105.959 111.849 109.641 110.911 117.501C109.973 125.36 110.341 133.883 110.341 133.883C110.341 133.883 118.42 135.722 124.53 134.192C130.64 132.662 136.995 132.209 142.307 133.073C147.619 133.938 159.693 135.439 160.658 141.045C161.623 146.651 155.061 150.557 147.466 151.597C139.872 152.637 140.122 154.272 133.377 153.649C126.633 153.027 122.226 152.302 116.423 152.741C110.62 153.18 99.2028 158.382 80.8522 158.795C62.5015 159.209 51.3387 153.319 42.5502 156.236C33.7618 159.154 20.6516 167.351 18.9815 170.877C18.9815 170.877 24.5587 164.078 19.1377 150.776C13.4454 136.83 4.95179 136.179 4.95179 136.179Z",
    fill: "#5BA0E0",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.736 136.523C149.001 136.334 151.919 136.535 153.808 137.134C157.94 138.448 158.124 140.532 158.123 141.831C158.124 143.337 157.342 145.329 156.198 146.305C153.569 148.54 146.039 150.101 144.475 148.622C143.264 147.481 143.274 138.882 143.33 138.075C143.423 136.431 144.421 136.728 146.736 136.523Z",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M110.341 133.883C107.839 133.557 105.727 133.637 103.41 132.968C100.13 132.02 96.7003 130.985 94.2812 128.578",
    stroke: "#24213A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M110.319 133.349C109.626 133.542 108.888 133.5 108.222 133.229C105.115 132.127 104.562 127.595 101.624 126.096",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M197.423 81.6647L188.917 82.0254C187.887 82.0691 186.829 82.1139 185.839 81.8515C184.85 81.589 183.883 80.977 183.459 80.0375",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M48.344 155.256C46.4039 155.264 45.2185 153.177 43.5651 152.164C42.8035 151.735 41.9722 151.443 41.1094 151.303C39.474 150.982 37.8016 150.893 36.1413 151.038",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3712 124.081C46.5953 124.209 49.9624 124.312 52.8862 122.95C54.9371 121.994 56.5937 120.394 58.4818 119.162C61.2317 117.369 64.4267 116.374 67.2565 114.713C69.7054 113.276 71.8369 111.368 74.0973 109.652C78.9305 105.988 84.3669 103.196 90.1612 101.402",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M150.943 94.1745C150.507 92.0248 150.332 89.8303 150.422 87.6386",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M152.039 93.596C151.643 93.4036 151.399 91.8221 151.576 90.0135",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M171.477 91.0427C171.213 89.3395 171.314 87.5995 171.774 85.9384",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.923 91.1649C172.754 90.3053 172.833 89.4153 173.151 88.599",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M114.914 110.41C115.781 114.141 118.18 115.152 119.565 117.171C120.169 118.056 120.574 119.057 121.148 119.967C122.455 122.073 124.518 123.593 126.649 124.858C127.142 125.153 127.721 125.658 127.486 126.179C127.35 126.478 121.629 128.691 119.331 128.6C117.406 128.526 115.073 128.198 113.149 128.142C111.225 128.087 110.129 128.87 110.247 131.654",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M121.967 121.101C123.144 119.424 124.569 117.305 124.83 115.281C124.87 114.658 125.017 114.047 125.264 113.474C125.548 112.918 126.095 112.453 126.718 112.455",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M127.486 126.184C128.937 124.942 130.899 124.462 132.556 124.363C134.214 124.265 136.044 123.853 136.925 122.454",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.902 128.222C123.081 128.016 123.708 128.336 124.452 129.276C125.196 130.216 125.625 131.352 126.195 132.404",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M110.92 117.5C112.029 119.05 112.802 120.402 113.914 121.952C114.388 122.61 114.867 123.282 115.118 124.055C115.37 124.827 116.312 126.653 113.556 128.158",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M115.385 126.232C117.838 126.544 122.573 126.392 123.178 122.365",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M112.523 119.889C114.017 119.786 115.09 119.387 116.498 118.879C117.905 118.371 118.078 117.452 118.656 116.073",
    stroke: "#24213A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { Svg404 as ReactComponent };
export default __webpack_public_path__ + "static/404.c547f64e.svg";